"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.News = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const News = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "news", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ id: "news", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M6 6v19h23V6H6zm-.962-2h24.924C30.535 4 31 4.448 31 5v21c0 .552-.465 1-1.038 1H5.038C4.465 27 4 26.552 4 26V5c0-.552.465-1 1.038-1z" }), (0, jsx_runtime_1.jsx)("path", { d: "M3 9v16h2V9H3zM2 7h4v20H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zM9 14h17a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zM9 10h17a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zM9 18h17a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2z" }), (0, jsx_runtime_1.jsx)("path", { d: "M29 6C26.212 16 18.545 22.333 6 25h23V6z", opacity: ".3" })] })) })));
};
exports.News = News;
